import { FC } from 'react'
import { useParams } from 'react-router-dom'
import ShipmentBulkUpload from './ShipmentBulkUpload'

/**
 * Ruta `/shipment/bulk-upload/:id/fix/upload` — subir el Excel corregido sobre SU carga.
 *
 * Es solo el puente entre la ruta y el modo corrección de `ShipmentBulkUpload`: lee el id
 * de la carga y se lo pasa. Todo lo demás (dropzone, parser, emparejado y editor) vive allá,
 * porque es exactamente el mismo camino que el de crear una carga; lo único que cambia es
 * que al guardar se actualizan las guías de esta carga en vez de crearse otras.
 */
const ShipmentBulkUploadFixUpload: FC = () => {
  const { id } = useParams<{ id: string }>()
  return <ShipmentBulkUpload correctionHeaderId={id} />
}

export default ShipmentBulkUploadFixUpload
